import React from "react";
import { SlideShell } from "../../../shared/components/SlideShell";

export const Slide13 = ({ t, total, onActive }) => {
  return (
    <SlideShell theme="emissor"
      index={12}
      total={total}
      label="Partner Program B"
      kicker={t.kicker}
      onActive={onActive}
      variant="plain"
      bgStyle={{
        "--slide-bg": "linear-gradient(115deg,#020202,#06110d 54%,#020202),radial-gradient(820px 560px at 68% 56%,rgba(216,182,46,.18),transparent 70%)"
      }}
    >

      <h2 dangerouslySetInnerHTML={{ __html: t.title }} />
      <p className="lead">{t.body}</p>

      <div className="split" style={{ marginTop: "32px", gridTemplateColumns: "1.1fr .9fr", alignItems: "start" }}>
        <div className="grid two" style={{ marginTop: "0", maxWidth: "none" }}>
          <div className="card">
            <span className="num">01</span>
            <h3>{t.c1Title}</h3>
            <p>{t.c1Body}</p>
          </div>
          <div className="card">
            <span className="num">02</span>
            <h3>{t.c2Title}</h3>
            <p>{t.c2Body}</p>
          </div>
          <div className="card">
            <span className="num">03</span>
            <h3>{t.c3Title}</h3>
            <p>{t.c3Body}</p>
          </div>
          <div className="card">
            <span className="num">04</span>
            <h3>{t.c4Title}</h3>
            <p>{t.c4Body}</p>
          </div>
        </div>
        
        <div
          className="image-card"
          style={{
            "--image-bg": "linear-gradient(145deg,rgba(216,182,46,.24),rgba(4,12,10,.22)), repeating-linear-gradient(90deg,rgba(255,255,255,.08) 0 1px,transparent 1px 46px), repeating-linear-gradient(0deg,rgba(216,182,46,.12) 0 1px,transparent 1px 46px)",
            minHeight: "520px"
          }}
        >
          <div className="caption">
            <div className="eyebrow">{t.imgEyebrow}</div>
            <h3>{t.imgTitle}</h3>
            <p className="body" style={{ maxWidth: "420px", marginTop: "16px" }}>{t.imgBody}</p>
          </div>
        </div>
      </div>
    </SlideShell>
  );
};





